import { DateTime } from 'luxon';
import { z } from 'zod';
import { zDateRange, zPrintOrientation, zPrintHeaderSize } from '../core';
export var CalendarPrintDomain;
(function (CalendarPrintDomain) {
    CalendarPrintDomain.Module = 'CalendarPrint';
    const module = z.literal(CalendarPrintDomain.Module);
    // Month view only for v1 - a generous multiple of a calendar month's worth
    // of days, so the worker (which builds one grid entry per day) never has
    // to render an unbounded print payload.
    const MAX_PRINT_DATE_RANGE_DAYS = 62;
    const zPrintDateRange = zDateRange.refine(({ start, end }) => 
    // +1: both endpoints are inclusive, so the day-count is one more than
    // the (exclusive) Luxon diff between them.
    DateTime.fromISO(end).diff(DateTime.fromISO(start), 'days').days + 1 <=
        MAX_PRINT_DATE_RANGE_DAYS, {
        message: `dateRange must not span more than ${MAX_PRINT_DATE_RANGE_DAYS} days`,
    });
    const zPrintOptions = z.object({
        view: z.literal('month'),
        orientation: zPrintOrientation,
        dateRange: zPrintDateRange,
        trackIds: z.array(z.uuid()),
        athleteId: z.uuid().nullable(),
        includeHubEvents: z.boolean(),
        // Default empty so BE clients can omit until the FE MR wires filter state through.
        deselectedHubEventTypeIds: z.array(z.string()).default([]),
        fitToPage: z.boolean(),
        headerText: z.string().max(100).nullable(),
        headerSize: zPrintHeaderSize,
        showCanceled: z.boolean(),
        locale: z.string().nullable(),
    });
    CalendarPrintDomain.Print = z.object({
        module,
        type: z.literal('Print'),
        input: z.object({
            printTaskId: z.uuid(),
            teamId: z.uuid(),
            trackIds: z.array(z.uuid()),
            athleteId: z.uuid().nullish(),
            dateRange: zPrintDateRange,
            printOptions: zPrintOptions,
        }),
    });
    CalendarPrintDomain.DeletePrintTask = z.object({
        module,
        type: z.literal('DeletePrintTask'),
        input: z.object({
            printTaskId: z.uuid(),
            teamId: z.uuid(),
        }),
    });
    CalendarPrintDomain.FetchPrintTaskInput = z.object({
        id: z.uuid(),
    });
})(CalendarPrintDomain || (CalendarPrintDomain = {}));
//# sourceMappingURL=print.js.map